import React from 'react';
import { motion } from 'framer-motion';

const WhoWeAre = () => {
  return (
    <section className="py-24 bg-white relative overflow-hidden">
      {/* Decorative side text */}
      <div className="absolute right-0 top-1/2 -translate-y-1/2 rotate-90 text-[10vw] font-bold text-slate-50 pointer-events-none whitespace-nowrap z-0 uppercase">
        VASTECH 2021
      </div>

      <div className="container mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="grid lg:grid-cols-12 gap-16 items-start">
          <motion.div
            initial={{ opacity: 0, x: -50 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8 }}
            className="lg:col-span-5"
          >
            <h2 className="text-sm font-bold uppercase tracking-[0.4em] text-[#91756A] mb-6 flex items-center">
              <span className="w-8 h-px bg-[#91756A] mr-4"></span> Who We Are
            </h2>
            <h3 className="text-4xl md:text-5xl font-bold text-[#4D4C4A] leading-[1.1] mb-12 italic tracking-tighter">
              Leading Engineering <br />
              <span className="text-[#91756A]">Solutions</span> Provider.
            </h3>
            
            <div className="p-8 border-l-4 border-[#91756A] bg-slate-50 italic">
              <p className="text-xl text-slate-600 leading-relaxed">
                "VASTECH is a leading engineering solutions provider specializing in advanced HVAC systems, smart elevator 
                technologies, and intelligent building infrastructure."
              </p>
            </div>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, x: 50 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8, delay: 0.2 }}
            className="lg:col-span-7 space-y-8 text-slate-500 text-lg leading-relaxed pt-12 lg:pt-24"
          >
            <p>
              Established in Sharjah in 2021, VASTECH has rapidly evolved from an installation-focused engineering firm 
              into a trusted provider of technology-driven infrastructure solutions across the UAE.
            </p>
            <p>
              Our expertise lies in developing integrated systems that combine vertical mobility, climate control, and 
              smart building technologies to improve how modern buildings function.
            </p>
            <p>
              By applying advanced engineering principles and innovative technologies, we help developers, consultants, 
              and property owners create buildings that are more efficient, reliable, and comfortable for occupants.
            </p>
            <p>
              Today, VASTECH supports projects across residential, commercial, and mixed-use developments, delivering 
              solutions designed to meet the demands of modern urban environments and intelligent infrastructure.
            </p>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default WhoWeAre;